[
    {
        "id":"254",
        "title": "Upgraded security"
    },
    {
        "id":"255",
        "title": "Every upload writes to the driver card"
    },
    {
        "id":"256",
        "title": "It can start when Windows is launched"
    },
    {
        "id":"257",
        "title": "The instant check feature is ideal for checking data on agency driver cards without uploading everything to Vision"
    },
    {
        "id":"258",
        "title": "Full check, enabling you to produce a full analysis report based on card data and other data added to Vision"
    },
    {
        "id":"259",
        "title": "Simple upload of data"
    },
    {
        "id":"260",
        "title": "Option to maintain your choice of upload type and auto-upload"
    },
    {
        "id":"261",
        "title": "It includes an in-built updater so future updates are checked for and are applied without a fresh install"
    }
]